import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { combineEpics } from "redux-observable";
import ExperimentResource from "../resources/expapiunified/Experiment.resource.js";
import FeatureResource from "../resources/expapiunified/Feature.resource.js";
import { prefix } from "./constants.js";
import { defaultGuid } from "../constants/guid.constants.js";
const loadAssignmentDetailsForExperiment = {
  actionPrefix: `${prefix}/EXPERIMENT/LOADV2`,
  reduxKeyNested: (inputPayload) => ["experiments", inputPayload.experimentId],
  loadResource: (inputPayload) => ExperimentResource.getExperimentRestResult(inputPayload.workspaceId, inputPayload.experimentId),
  onCompleteSuccess: (resourceResult) => resourceResult,
  // If this experiment is part of a rollout, load feature data to get assignment unit
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => !outputPayload.featureId || outputPayload.featureId === defaultGuid || inputPayload.skipLoadFeature ? [] : [
    loadAssignmentDetailsForFeatureEpicReducer.actionCreators.load({
      workspaceId: inputPayload.workspaceId,
      featureId: outputPayload.featureId
    })
  ]
};
const loadAssignmentDetailsForExperimentEpicReducer = loadResourcesUtils(loadAssignmentDetailsForExperiment);
const loadAssignmentDetailsForFeature = {
  actionPrefix: `${prefix}/FEATURE/LOADV2`,
  reduxKeyNested: (inputPayload) => ["features", inputPayload.featureId],
  loadResource: (inputPayload) => FeatureResource.getFeature(inputPayload.workspaceId, inputPayload.featureId),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadAssignmentDetailsForFeatureEpicReducer = loadResourcesUtils(loadAssignmentDetailsForFeature);
const rootEpic = combineEpics(
  loadAssignmentDetailsForExperimentEpicReducer.epic,
  loadAssignmentDetailsForFeatureEpicReducer.epic
);
export {
  rootEpic as default,
  loadAssignmentDetailsForExperimentEpicReducer,
  loadAssignmentDetailsForFeatureEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
